import React from "react";
import { useFormik } from "formik";
import PropTypes from "prop-types";
import * as Yup from "yup";

import Button from "../../components/button";
import ICInput from "../../components/form/input";

const AddConsultNoteTemplateForm = props => {
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      templateName: ""
    },
    validationSchema: Yup.object({
      templateName: Yup.string().required("Please enter template name")
    }),
    onSubmit: values => {
      props.onAddSubmit(values.templateName);
      formik.resetForm();
    }
  });

  return (
    <form
      className="container d-flex flex-column mr-4 pr-4"
      onSubmit={formik.handleSubmit}
    >
      <div className="form-group row">
        <label className="col-sm-4 col-form-label font-demi-bold">
          Template Name:<span className="error">*</span>{" "}
        </label>
        <div className="col-sm-8">
          <ICInput
            name="templateName"
            type="text"
            value={formik.values.templateName}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={!!formik.touched.templateName}
            helperText={
              formik.touched.templateName && formik.errors.templateName
                ? formik.errors.templateName
                : ""
            }
          />
        </div>
      </div>
      <br />
      <p className="mb-0 d-flex justify-content-center">
        <Button title="Save" type="submit" />
        <Button
          className="insta-button-primary ml-3 mr-3"
          title="Cancel"
          type="button"
          clickEvent={() => {
            formik.resetForm();
            props.cancelEvent();
          }}
        />
      </p>
    </form>
  );
};

export default AddConsultNoteTemplateForm;

AddConsultNoteTemplateForm.defaultProps = {
  onAddSubmit: () => {},
  cancelEvent: () => {}
};

AddConsultNoteTemplateForm.propTypes = {
  onAddSubmit: PropTypes.func,
  cancelEvent: PropTypes.func
};
